import React from 'react'
import { FormattedMessage } from 'react-intl'
import SignupForm from '../components/signup/SignupForm'

const Signup = () => {

  const afterUserSignup = () => { window.location.href = '/ski365/signup-complete' }

  const email = new URL(window.location.href).searchParams.get("email")

  return (
    <div className="container mx-auto px-2 md:px-0">
      <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
        <div className="border-b pb-8">
          <h5 className="uppercase text-sky tracking-wide-2xl">
            <FormattedMessage id="signup.category" defaultMessage="Member" />
          </h5>
          <h1 className="text-4xl">
            <FormattedMessage id="signup.header" defaultMessage="SKI365 COMMUNITY" />
          </h1>
          <h2>
            <FormattedMessage id="signup.header2" defaultMessage="Be the first to get the latest news and advantages" />
          </h2>
          <p>
            <FormattedMessage id="signup.description.ln1" defaultMessage="By signing up to our newsletter you become a member of SKI365 - Denmarks new ski sport community, where you get advantages, discounts, special invitations and last but not least access to ski con CopenHill - Denmarks new epicenter for urban mountain sport" />
          </p> 
          <p>
            <FormattedMessage id="signup.description.ln2" defaultMessage="Sign up using the form below and receive information from CopenHill and SKI365 - your advantages starts here, and you are a free basis member as long as you receive our newsletter" />
          </p> 
        </div>
        <SignupForm afterUserSignup={afterUserSignup} userInfo={{email}} />
      </div>
    </div>
  );
}

export default Signup